module.exports = __webpack_public_path__ + "img/switzerland-neoplasm-female.c982d415.png";